import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=45f0b316&"
import script from "./AddElement.vue?vue&type=script&lang=ts&"
export * from "./AddElement.vue?vue&type=script&lang=ts&"
import style0 from "./AddElement.vue?vue&type=style&index=0&id=45f0b316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports